import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import ContactForm from '../components/ContactForm';
import { HOW_IT_WORKS } from '../data/mock';

export default function PlanWedding() {
  return (
    <main className="pt-32">
      <section className="relative">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#053e49]/85" />
        </div>
        <div className="relative max-w-[1240px] mx-auto px-6 md:px-10 py-24 text-[#faf4ea]">
          <SectionLabel dark>Plan My Wedding</SectionLabel>
          <Heading dark className="mt-5 font-serif max-w-3xl">Every destination wedding begins<br/><span className="italic text-[#ffeabf]">with a conversation.</span></Heading>
          <p className="mt-6 max-w-2xl text-[#d8d0bf] text-lg">Share your ideas below. A Sunday Mirror wedding specialist will respond within 48 hours.</p>
        </div>
      </section>

      <section className="bg-[#faf4ea] py-24">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-7">
            <SectionLabel>Start Planning</SectionLabel>
            <Heading className="mt-5 font-serif">Tell us <span className="italic">about your wedding.</span></Heading>
            <div className="mt-10"><ContactForm /></div>
          </div>
          <aside className="lg:col-span-5">
            <div className="sticky top-28">
              <div className="eyebrow text-[#a6894f]">What happens next</div>
              <div className="mt-6 space-y-6">
                {HOW_IT_WORKS.map((s) => (
                  <div key={s.num} className="flex gap-5">
                    <span className="font-serif text-3xl text-[#c3a66d] leading-none pt-1">{s.num}</span>
                    <div>
                      <div className="font-serif text-xl text-[#053e49]">{s.title}</div>
                      <div className="text-sm text-[#4a5c60] mt-1">{s.body}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
